type FullscreenElementWithWebkit = HTMLElement & {
  webkitRequestFullscreen?: () => Promise<void> | void;
};

type FullscreenDocumentWithWebkit = Document & {
  webkitExitFullscreen?: () => Promise<void> | void;
  webkitFullscreenElement?: Element | null;
};

/** Returns the element currently displayed in fullscreen, if any. */
export function getActiveFullscreenElement(): Element | null {
  const fullscreenDocument = window.document as FullscreenDocumentWithWebkit;
  return (
    fullscreenDocument.fullscreenElement ??
    fullscreenDocument.webkitFullscreenElement ??
    null
  );
}

/** Requests fullscreen for the given element (standard + webkit). */
export async function requestElementFullscreen(
  element: HTMLElement,
): Promise<void> {
  const fullscreenElement = element as FullscreenElementWithWebkit;
  if (typeof fullscreenElement.requestFullscreen === "function") {
    await fullscreenElement.requestFullscreen();
    return;
  }
  if (typeof fullscreenElement.webkitRequestFullscreen === "function") {
    await fullscreenElement.webkitRequestFullscreen();
  }
}

/** Exits the active fullscreen session (standard + webkit). */
export async function exitActiveFullscreen(): Promise<void> {
  const fullscreenDocument = window.document as FullscreenDocumentWithWebkit;
  if (typeof fullscreenDocument.exitFullscreen === "function") {
    await fullscreenDocument.exitFullscreen();
    return;
  }
  if (typeof fullscreenDocument.webkitExitFullscreen === "function") {
    await fullscreenDocument.webkitExitFullscreen();
  }
}

/** Toggles fullscreen for the given canvas element. */
export async function toggleElementFullscreen(
  element: HTMLElement,
): Promise<void> {
  if (getActiveFullscreenElement() === element) {
    await exitActiveFullscreen();
    return;
  }
  await requestElementFullscreen(element);
}

export const RUNTIME_LAYOUT_CONTEXT_MENU_Z_INDEX = 2_000_000;
export const RUNTIME_LAYOUT_CONTEXT_MENU_WIDTH = 220;
export const RUNTIME_LAYOUT_CONTEXT_MENU_HEIGHT = 48;
